import {createUseQuery} from "@irati/utils/services/apollo"
import {gql} from "@irati/utils/gql"
import {
  CashbackTransactionsListResponse,
  CashbackTransactionTotalAmount,
  QueryCashbackTransactionsListArgs,
  QueryCashbackTransactionsTotalAmountArgs
} from "@irati/types"
export const useCashbackTransactionTotalAmount = createUseQuery<CashbackTransactionTotalAmount, QueryCashbackTransactionsTotalAmountArgs>(
  gql`
    query CashbackTransactionsTotalAmount($userId: ID!, $status: CashbackTransactionStatus!, $currency: String!) {
      cashbackTransactionsTotalAmount(userId: $userId, status: $status, currency: $currency) {
        amount
        count
        currency
      }
    }
  `,
  {
    key: "cashbackTransactionsTotalAmount"
  }
)
export const useCashbackTransactionList = createUseQuery<CashbackTransactionsListResponse, QueryCashbackTransactionsListArgs>(
  gql`
    query CashbackTransactionsList($filters: CashbackTransactionListFilters, $limit: Int, $searchAfter: String) {
      cashbackTransactionsList(filters: $filters, limit: $limit, searchAfter: $searchAfter) {
        results {
          uuid
          amount
          status
          deal {
            header
            cashbackETADays
            thumbnailImage
          }
          dateUnix
          metadata {
            createdAt
            updatedAt
          }
        }
        nextSearchAfter
        total
      }
    }
  `,
  {
    key: "cashbackTransactionsList"
  }
)
